export default "__VITE_ASSET__wTiww$yw__"